import React from "react";
import { Box, Typography } from "@mui/material";

export default function Title({ title, secondaryTitle }) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 0.5,
            }}
        >
            <Typography
                sx={{
                    fontFamily: "Cairo-Bold",
                    fontSize: "18px",
                    color: "#1e293b",
                }}
            >
                {title}
            </Typography>
            {secondaryTitle && (
                <Typography
                    sx={{
                        fontFamily: "Cairo-Medium",
                        fontSize: "12px",
                        color: "#64748b",
                    }}
                >
                    {secondaryTitle}
                </Typography>
            )}
        </Box>
    );
}
